/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import axiosRetry from 'axios-retry'

import IHTTPClient, { DefaultHeaders } from '../types/HTTPClient.interface'

const defaultOptions = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
}

class HTTPClient implements IHTTPClient {
  client: AxiosInstance
  token?: string
  language?: string

  constructor() {
    this.client = axios.create(defaultOptions)

    axiosRetry(this.client, { retries: 3 })
  }

  _getLanguage() {
    const headerLanguages: Record<string, string> = {
      'pt-BR': 'pt-BR, en-US',
      de: 'de, en-US',
      en: 'en-US'
    }

    return headerLanguages[this.language || 'en']
  }

  _updateHeaders() {
    this.client.defaults.headers = {
      ...defaultOptions.headers,
      'Accept-Language': this._getLanguage(),
      ...(this.token && { AUTH_TOKEN: this.token })
    } as DefaultHeaders
  }

  setToken(token: string) {
    this.token = token
    this._updateHeaders()
  }

  setLanguage(language: string) {
    this.language = language
    this._updateHeaders()
  }

  get<T = any>(url: string, config?: AxiosRequestConfig<any> | undefined) {
    return this.client.get<T>(url, config)
  }

  post<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return this.client.post<T>(url, data, config)
  }

  put<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return this.client.put<T>(url, data, config)
  }

  patch<T = any>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any> | undefined
  ) {
    return this.client.patch<T>(url, data, config)
  }

  delete<T = any>(url: string, config?: AxiosRequestConfig<any> | undefined) {
    return this.client.delete<T>(url, config)
  }
}

export default new HTTPClient()
